import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { API_BASE_URL } from '../injection-tokens';
import { AuthStatus } from '../models/auth-status.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private apiBaseUrl = inject(API_BASE_URL);
  private platformId = inject(PLATFORM_ID);

  isLoggedIn(): Observable<boolean> {
    return this.http.get<AuthStatus>(`${this.apiBaseUrl}/v1/auth/status`).pipe(
      map((response) => response?.isAuthenticated === true),
      catchError(() => of(false)),
    );
  }

  getAuthStatus(): Observable<AuthStatus> {
    return this.http.get<AuthStatus>(`${this.apiBaseUrl}/v1/auth/status`);
  }

  logout() {
    // Only execute redirection in browser environment
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = `${this.apiBaseUrl}/v1/auth/logout`;
    }
  }

  redirectToLogin() {
    // Only execute redirection in browser environment
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = window.location.href;
      window.location.href = `${this.apiBaseUrl}/v1/auth/login?redirectUrl=${encodeURIComponent(currentUrl)}`;
    }
  }
}
